var _path, _circle, _circle2, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatienticonheartFailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 15.5002C26.1039 19.8578 19.8211 25.1002 17.2281 27.09C16.5682 27.5963 15.6727 27.6017 15.0068 27.1034C12.3613 25.1238 5.89704 19.8676 5.5 15.5002C5.5 9.82717 9.83422 2.00024 16.1223 2.00024C22.4103 2.00024 26.5 9.82717 26.5 15.5002Z",
    fill: "#F3D2D2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 11,
    fill: "#F3D2D2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 9,
    fill: "#F3D2D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1586 7.21006C14.1586 7.21006 14.5748 6.50269 15.8388 6.50269C17.1027 6.50269 17.5894 7.19998 17.5894 7.19998C17.5894 7.19998 17.8431 8.23616 17.6143 8.44878C17.3636 8.68199 17.1931 7.9773 15.8689 7.95724C14.5446 7.93718 13.9629 8.57922 13.9629 8.57922L14.1586 7.21006Z",
    fill: "#C53434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2401 7.10254C14.2401 7.10254 13.4375 7.7714 16.3801 11.1687C19.3228 14.5661 19.7508 15.8502 19.7508 15.8502L18.654 18.8731C18.654 18.8731 16.0324 14.5929 14.6414 12.6401C13.2502 10.6873 12.7863 9.04788 14.2401 7.10254Z",
    fill: "#9E2A2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5107 7.10278C17.5107 7.10278 18.3132 7.77165 15.3706 11.169C12.428 14.5664 12 15.8505 12 15.8505L13.0968 18.8733C13.0968 18.8733 15.7183 14.5931 17.1093 12.6404C18.5005 10.6875 19.1383 9.02817 17.5107 7.10278Z",
    fill: "#C53434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatienticonheartFailure);
export default __webpack_public_path__ + "static/media/patienticonheart-failure.342ea0714db00472b42ecd688092f617.svg";
export { ForwardRef as ReactComponent };